import React from 'react';
import ojkLogo from 'assets/images/backoffice/capital/ojk-logo.png';
import styles from './Header.css';

function Header() {
  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>Capital</p>
      <img
        src={ojkLogo}
        className={styles['ojk-logo']}
        data-testid="header-logo"
      />
    </div>
  );
}

export default Header;
